// Source sheet: https://docs.google.com/spreadsheets/d/141hKMNAZjz1g-6CnfzvTtyCyuuNJcSCCNoD9TSacBxI/edit?gid=0#gid=0
export const commercialUseVehicles: Record<string, string[]> = {
  chevrolet: ['silverado 3500', 'express'],
  ford: ['f350', 'f450', 'transit', 'transit connect', 'e-series'],
  'mercedes-benz': ['sprinter', 'metris'],
  freightliner: ['sprinter'],
  gmc: ['sierra 3500', 'savana 2500', 'savana 3500'],
  nissan: ['nv 2500/3500', 'nv 2500', 'nv 3500', 'nv 1500', 'nv 200'],
  ram: ['3500', '1500 promast', '2500 promast', 'promast city']
};

// Business-use cars (`primaryUse === 'B'`) are excluded — they already trigger a separate Front ticket.
export const isPotentialCommercialVehicle = (
  make: string | null,
  model: string | null,
  primaryUse: string | null
): boolean => {
  const normalizedMake = make?.toLowerCase();
  const normalizedModel = model?.toLowerCase();

  if (!normalizedMake || !normalizedModel || primaryUse === 'B') {
    return false;
  }

  const commercialModels = commercialUseVehicles[normalizedMake];
  if (!commercialModels) {
    return false;
  }

  const modelRegex = new RegExp(`^(${commercialModels.join('|')})\\b`, 'i');
  return modelRegex.test(normalizedModel);
};
